import { core } from '@tock/coretypes';
import { getAppTarget } from 'utils/deviceUtils';

export interface UseIsSupportedApplePayEnvironmentParams {
  isConcierge?: boolean;
  isTableSideOrder?: boolean;
  isCreditCardHold?: boolean;
}

export const convertTicketTypeToParams = (
  ticketType?: core.TicketType | core.ITicketType
): UseIsSupportedApplePayEnvironmentParams => ({
  isTableSideOrder: ticketType?.variety === 'TABLESIDE',
  isCreditCardHold: !!(ticketType?.ticketTypePriceConfig ?? []).find(
    ({ priceType }) => priceType === 'PAYMENT_CARD_HOLD'
  ),
});

export const isSupportedApplePayEnvironment = (
  params: UseIsSupportedApplePayEnvironmentParams
): boolean => {
  const appTarget = getAppTarget();

  // hide/disable Apple Pay when checking out inside the old iOS app(s)
  const isLegacyApp = appTarget === 'ReactNative';
  // hide/disable Apple Pay when checking out as a concierge
  const isConcierge = !!params.isConcierge;
  // hide/disable Apple Pay when checking out a table side order
  const isTableSideOrder = !!params.isTableSideOrder;
  // hide/disable Apple Pay when checking out a credtit card hold
  const isCreditCardHold = !!params.isCreditCardHold;
  // hide/disable Apple Pay when rendering in an iFrame
  const inIFrame = window.self !== window.top;
  // hide/disable Apple Pay when using HTTP instead of HTTPS
  const isSecure = window.location.protocol === 'https:';

  return (
    !isLegacyApp && !isConcierge && !isTableSideOrder && !isCreditCardHold && !inIFrame && isSecure
  );
};

export const useIsSupportedApplePayEnvironment = (
  params: UseIsSupportedApplePayEnvironmentParams
): boolean => {
  return isSupportedApplePayEnvironment(params);
};
